exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-title,.popular-searches-text{color:#fff!important}.breadcrumb-title{font-size:36px!important}.breadcrumb-desc{font-size:21px!important;color:#fff!important;font-family:artifaktElementBold!important}.search-input{opacity:1!important;border-radius:25px!important;height:100%!important;font-size:18px!important;font-family:artifaktElementRegular!important;font-style:italic;line-height:18px!important}", ""]);

// exports
